import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import HeroImg from './programmer.png';


function Hero() {
    return (
        <Container className='mt-5'>
            <Row>
                <Col><img src={HeroImg} className="hero-image" /></Col>
                <Col>
                    <Card  bg={"dark"} text='white' className="hero-card" >
                        <Card.Body>
                            <Card.Title id="about" className='hero-card-title'>About Me</Card.Title>
                            <Card.Text>
                             My experience includes crafting successful and user-friendly websites using HTML, React, JavaScript, CSS  and  liquid. I possess a highly creative mindset which allows me to come up with out of the box solutions for complex challenges. 
                            </Card.Text>
                            <Button href="#contact" variant="outline-light">Contact me</Button>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Hero;